module.exports = __webpack_public_path__ + "media/audio88.a9436516.mp3";